export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12941.c1703247.jpg";